module.exports = __webpack_public_path__ + "static/media/classThree.04fed69d.jpg";